import { useQuery } from 'react-query';
import FatAndProteinService from '~/api/services/fatAndProtein';
import { onError } from '~/utils/helpers';

const getMilkFixexPriceList = (data?) => useQuery(
  `fat-and-protein-list-${data.search}`,
  () => FatAndProteinService.getMilkFixedPriceIndex(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceListOptions = () => useQuery(
  'fat-and-protein-list-options',
  FatAndProteinService.getMilkFixedPriceIndexData,
  {
    onError,
    refetchOnMount: false,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOptions = () => useQuery(
  'fat-and-protein-options',
  FatAndProteinService.getMilkFixedPriceOptions,
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceCount = (data?) => useQuery(
  `fat-and-protein-count-${data.search}`,
  () => FatAndProteinService.countTradingSlots(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOffers = (id, data?) => useQuery(
  'fat-and-protein-offers',
  () => FatAndProteinService.offersPreviewTradingSlot(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOffersByOptions = (id, farmerId?) => useQuery(
  'fat-and-protein-offers-list',
  () => FatAndProteinService.offersPreviewTradingSlotByMonths(id, farmerId),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOffersData = (id, farmerGroupId, data?) => useQuery(
  'fat-and-protein-offers-data',
  () => FatAndProteinService.getOffersData(id, farmerGroupId, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getMilkFixexPriceOffersSettings = (id) => useQuery(
  'fat-and-protein-offers-settings',
  () => FatAndProteinService.offersPreviewTradingSlotOptions(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getTradingActivities = (data?) => useQuery(
  'fat-and-protein-trading-activities',
  () => FatAndProteinService.getTradingActivities(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

const getTradingActivityOptions = () => useQuery(
  'fat-and-protein-activity-options',
  () => FatAndProteinService.offersStatusOptions(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerSettingsMilk = () => useQuery(
  'fat-and-protein-farmer-trading-options',
  () => FatAndProteinService.getTradingSlotsFarmerSettings(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

export const FatAndProteinQuery = {
  getMilkFixexPriceList,
  getMilkFixexPriceListOptions,
  getMilkFixexPriceOptions,
  getMilkFixexPriceCount,
  getMilkFixexPriceOffers,
  getMilkFixexPriceOffersByOptions,
  getMilkFixexPriceOffersSettings,
  getTradingActivities,
  getTradingActivityOptions,
  getFarmerSettingsMilk,
  getMilkFixexPriceOffersData
}

